<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2024-02-23 16:39:01
 * @LastEditors: sjq
 * @LastEditTime: 2024-02-26 09:17:27
 -->
<template>
  <div class="continer_box">
    <div class="pay-success">
      <!-- 菜单栏（内嵌App时隐藏） -->
      <app-header :title="title" :transparent="true" back-type="back-app" />
      <div class="pay-status">
        <span class="img-success"></span>
        <div class="course-text">
          <div class="course-success">恭喜您！激活成功</div>
        </div>
      </div>
      <div class="pay-user" v-if="user">
        <div class="vip-tip">
          <p>请添加下方班主任二维码，</p>
          <p>复制您的学号并发送给班主任。</p>
          <p class="vip-tip-magin">
            学号: {{ user.associationSno }}
            <span class="vip-tip-copy" @click="copyCode($event)">复制</span>
          </p>
        </div>

        <!-- 微信二维码 -->
        <div class="user-teacher">
          <div>
            <div class="img-qrcode">
              <img class="img" :src="user.adviserCode" />
            </div>
            <div v-if="user.adviserName" class="img-text">
              {{ user.adviserName || '' }}
            </div>
            <div class="img-text">添加班主任微信，激活课程服务</div>
            <div class="mt20">
              <div class="text" v-if="!isNative">长按扫码添加班主任微信</div>
              <div class="text btn-common" style="display: inline-block" v-else @click="nativeGoMini($event)">
                点击添加班主任
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import copyText from '@/utils/clipboard'
import { MessageBox } from 'mint-ui'
import { mapGetters } from 'vuex'
import { appUser } from '@/utils'
import { $gotoMiniProgramV2 } from '@/utils/common/native-api'

const componentName = 'activationAdviser'
export default {
  name: componentName,
  componentName,
  data() {
    return {
      title: ''
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('goods/activation', ['user']),
    isNative() {
      return appUser.isNative
    }
  },
  created() {
    if (!this.user.userId) {
      this.$router.replace({
        name: 'activation'
      })
    }
  },
  methods: {
    copyCode(event) {
      const text = this.user.associationSno
      copyText(text, event)
      MessageBox({
        title: '',
        message: '学号复制成功，请扫描二维码添加班主任老师为好友，把复制好的学号发给老师',
        confirmButtonText: '我知道了',
        confirmButtonClass: 'button-i_see'
      }).then(() => {
        this.step = 2
      })
    },
    nativeGoMini(event) {
      this.$store.dispatch('user/login/getMiniParam', {}).then(mini => {
        $gotoMiniProgramV2({
          miniUserName: mini.miniUserName,
          goMiniUrl:
            'pages/rights_receive/app_add_headTeacher/app_add_headTeacher?userId=' + this.user.userId + '&sceneId=3'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.continer_box {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7f9fb;
}
.pay-wxk-status {
  position: relative;
  .pay-wxk-status-bg {
    width: 100%;
  }
  .yh-imgs {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1rem;
    img {
      width: 100%;
    }
  }
  .course-text {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
    margin-top: 1rem;
    color: #00b25a;
    font-size: 0.28rem;
    .course-success {
      margin-bottom: 0.32rem;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      .img-icon {
        border-radius: 50%;
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.16rem;
      }
    }
    .desk {
      font-size: 0.52rem;
      font-weight: bold;
    }
  }
}

.pay-success {
  background: url('../../images/payment/success_BG_ellipse_left.png') no-repeat,
    url('../../images/payment/success_BG_ellipse_right.png') no-repeat,
    url('../../images/payment/success_BG.png') no-repeat;
  background-color: #f7f9fb;
  background-size: 52px 79px, 65px 100px, 100% 40%;
  background-position-x: left, right, center;
  background-position-y: 22%, 7%, top;
  //position: fixed;
  //left: 0;
  //right: 0;
  //top: 0;
  //bottom: 0;
  // 支付状态
  .pay-status {
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0 20px 0;
    color: white;
    text-align: center;
    .img-success {
      display: inline-block;
      width: 48px;
      height: 48px;
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin-bottom: 20px;
      background: url('../../images/payment/icon_choose_large_def.png') no-repeat;
      background-size: 20px;
      background-position: center;
    }
    // 课程引导
    .course-text {
      .course-success {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        opacity: 1;
      }
      // 进入书桌
      .desk {
        margin-top: 10px;
        height: 17px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 17px;
      }
      .coupon_tip {
        font-size: 15px;
        font-weight: 600;
        color: #ffffff;
        margin: 0 15%;
        padding: 0.2rem 0 0.3rem;
      }
    }
  }
}
.pay-user {
  text-align: center;
  padding-bottom: 40px;
  padding-top: 40px;
  background-color: #ffffffff;
  margin: 40px 20px 20px;
  border-radius: 10px;
  .vip-tip {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    .vip-tip-magin {
      margin-top: 14px;
      .vip-tip-copy {
        font-size: 12px;
        color: #00b25a;
        background-color: #f0f7f7;
        padding: 3px 8px 3px 8px;
        margin-left: 6px;
        border-radius: 2px;
      }
    }
  }
  // 班主任二维码
  .user-teacher {
    margin: 20px 0;
    color: #00b25a;
    .img {
      width: 150px;
      height: 150px;
      margin: 5px 0;
      border: 1px solid #dddddd;
    }
    .img-text {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    .img-text-tip {
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>
